import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'knbr-kn-br-add-to-cart-alert-popup',
  templateUrl: './kn-br-add-to-cart-alert-popup.component.html',
  styleUrls: ['./kn-br-add-to-cart-alert-popup.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class KnBrAddToCartAlertPopupComponent {
  @Input() header = 'Quantity Overage Alert';
  @Input() message =
    'Requested quantity is higher than maximum allowed. Please add reason at checkout.';
  @Input() buttonText = 'OK';
  @Input() showViewCart = false;
  @Input() showClearCart = false;
  @Input() showConfirmation = false;
  @Input() viewCartText = 'View Cart';
  @Input() clearCartText = 'Clear Cart';
  @Input() confirmText = 'Yes';
  @Input() cancelText = 'No';

  constructor(public activeModal: NgbActiveModal) {}

  get messageLines(): string[] {
    return (this.message || '').split('\n').map((l) => l.trim()).filter(Boolean);
  }

  dismissModal(): void {
    this.activeModal.close({ action: 'ok' });
  }

  viewCart(): void {
    this.activeModal.close({ action: 'viewCart' });
  }

  clearCart(): void {
    this.activeModal.close({ action: 'clearCart' });
  }

  confirm(): void {
    this.activeModal.close({ action: 'confirm' });
  }

  cancel(): void {
    this.activeModal.close({ action: 'cancel' });
  }
}
